<template>
  <div
    class="sidebar-container"
    v-show="c_show"
    :class="{
      expand: c_expand,
      'left-sidebar-container': left,
      'right-sidebar-container': right,
      'auto-sidebar-container': isAutoWidth,
    }"
    :style="styleSideBar"
  >
    <v-card v-show="c_show" class="full-width full-height" flat>
      <slot />
    </v-card>

    <div
      v-if="!disabledExpand && !isMobile && c_show"
      class="complex-button-close"
      :style="styleButtonClose"
    >
      <v-tooltip :left="right" :right="left" disabled>
        <template v-slot:activator="{ on, attrs }">
          <v-sheet
            v-bind="attrs"
            class="d-flex align-center"
            elevation="1"
            height="48px"
            width="23px"
            v-on="on"
            @click="onToggleExpand"
          >
            <span v-if="left">
              <v-icon>{{
                c_expand ? 'mdi-menu-left' : 'mdi-menu-right'
              }}</v-icon>
            </span>
            <span v-else-if="right">
              <v-icon>{{
                !c_expand ? 'mdi-menu-left' : 'mdi-menu-right'
              }}</v-icon>
            </span>
          </v-sheet>
        </template>
        <span v-if="left">{{
          c_expand
            ? 'Thu gọn bảng điều khiển bên cạnh'
            : 'Mở rộng bảng điều khiển bên cạnh'
        }}</span>
        <span v-else-if="right"
          >{{
            !c_expand
              ? 'Thu gọn bảng điều khiển bên cạnh'
              : 'Mở rộng bảng điều khiển bên cạnh'
          }}
        </span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    right: Boolean,
    disabledExpand: Boolean,
    width: { type: [String, Number], default: 'auto' },
  },
  data: () => ({ p_show: true, p_expand: true }),
  computed: {
    isAutoWidth() {
      return !this.width || this.width == 'auto'
    },
    left() {
      return !this.right
    },
    c_width() {
      if (this.isAutoWidth) return ''
      return this.width + 'px'
    },
    styleSideBar() {
      if (this.isMobile) {
        return {
          width: '100%',
        }
      }
      return {
        width: this.c_expand ? this.c_width : 0,
      }
    },
    styleButtonClose() {
      let style = {}
      if (this.left) {
        style.left = this.c_expand ? this.c_width : 0
      } else {
        style.right = this.c_expand ? this.c_width : 0
      }
      return style
    },
    c_show: {
      get() {
        return this.p_show
      },
      set(value) {
        this.p_show = value
        this.$emit('update:show', value)
      },
    },
    c_expand: {
      get() {
        return this.p_expand
      },
      set(value) {
        this.p_expand = value
        this.$emit('update:expand', value)
      },
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.p_show = value
      },
    },
  },
  methods: {
    onToggleExpand() {
      this.c_expand = !this.c_expand
      if (this.right) {
        return
      }
      const collection = document.getElementsByClassName('show-sidebar-left')
      Array.from(collection).forEach((element) => {
        if (!this.c_expand) {
          element.classList.add('sidebar-left-close')
        } else {
          element.classList.remove('sidebar-left-close')
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
@media only screen and (max-width: 600px) {
  .auto-sidebar-container {
    width: 100%;
  }
}
@media only screen and (min-width: 600px) and (max-width: 1264px) {
  .auto-sidebar-container.expand {
    width: 320px;
  }
  .auto-sidebar-container.expand.left-sidebar-container .complex-button-close {
    left: 320px !important;
  }
  .auto-sidebar-container.expand.right-sidebar-container .complex-button-close {
    right: 320px !important;
  }
}
@media only screen and (min-width: 1264px) {
  .auto-sidebar-container.expand {
    width: 400px;
  }
  .auto-sidebar-container.expand.left-sidebar-container .complex-button-close {
    left: 400px !important;
  }
  .auto-sidebar-container.expand.right-sidebar-container .complex-button-close {
    right: 400px !important;
  }
}
.sidebar-container {
  position: absolute;
  pointer-events: all;
  z-index: 900;
  top: 0;
  border-right: solid 1px #ccc;
}

.sidebar-container {
  transition: all 0.2s ease;
}
.complex-button-close {
  position: absolute;
  top: 50%;
  transition: max-width 1s;
  transition: all 0.2s ease;
}
.left-sidebar-container {
  left: 0;
}
.right-sidebar-container {
  right: 0;
}
.sidebar-container {
  width: 0;
}
</style>

<style lang="scss" scoped>
.sidebar-container {
  &.left-sidebar-container {
    .complex-button-close {
      left: 0;
      transform: translateY(-50%);
    }
  }
  &.right-sidebar-container {
    .complex-button-close {
      right: 0;
      transform: translateY(-50%);
    }
  }
}
</style>
